import { CarouselProps } from '../lib/carouselProps';
import Carousel from '../carousel';

window.BigCommerce = window.BigCommerce || {};
window.BigCommerce.initializeCarouselV2 = (props: CarouselProps): Carousel => {
    return new Carousel(props);
};
